export default "__VITE_ASSET__0553b654__"